import T from "prop-types";
import styled from "styled-components";
import { Container, H2, P } from "@nested/nested-react-components";

import { Card } from "./Card";

const TextContainer = styled(Container)`
  text-align: center;
  ${(props) => props.autoMargin && "margin-top: auto;"};
`;

const CardTitle = styled(P)`
  width: 200px;
  padding: 15px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 30px;
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: 20px;
  margin-top: auto;
`;

const ColoredH2 = styled(H2)`
  color: ${(props) => props.color || "currentcolor"};
`;
const ColoredP = styled(P)`
  color: ${(props) => props.color || "currentcolor"};
  font-weight: ${({ theme }) => theme.font.bold};
`;

function ResearchCard({ title, summary, color, textColor, to }) {
  return (
    <Card color={color} to={to}>
      <TextContainer align="center" autoMargin={!!to}>
        <ColoredH2 color={textColor}>{title}</ColoredH2>
        <ColoredP color={textColor}>{summary}</ColoredP>
      </TextContainer>
      {to && <CardTitle>View story</CardTitle>}
    </Card>
  );
}

ResearchCard.propTypes = {
  title: T.string,
  summary: T.string,
  color: T.string,
  textColor: T.string,
  to: T.string,
};

export { ResearchCard };
